import {
  humanizeKey,
  isPlainObject,
  sanitizeObject,
  HIDDEN_KEYS,
} from "./analysisUtils";

function JsonRenderer({ value, depth = 0, hiddenKeys = HIDDEN_KEYS }) {
  if (value == null) {
    return <span className="text-base-content/60">—</span>;
  }
  if (typeof value === "string") {
    return <div className="whitespace-pre-line break-words">{value}</div>;
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return <div className="break-words">{String(value)}</div>;
  }
  if (Array.isArray(value)) {
    if (value.length === 0) {
      return <span className="text-base-content/60">—</span>;
    }
    const allObjects = value.every((v) => isPlainObject(v));
    if (allObjects) {
      const sanitizedRows = value.map((row) => sanitizeObject(row, hiddenKeys));
      const columns = Array.from(
        new Set(sanitizedRows.flatMap((row) => Object.keys(row))),
      );
      return (
        <div className="overflow-x-auto">
          <table className="table table-zebra table-sm">
            <thead>
              <tr>
                {columns.map((c) => (
                  <th key={c} className="whitespace-nowrap">
                    {humanizeKey(c)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sanitizedRows.map((row, idx) => (
                <tr key={idx}>
                  {columns.map((c) => (
                    <td key={c} className="align-top">
                      <JsonRenderer
                        value={row?.[c]}
                        depth={depth + 1}
                        hiddenKeys={hiddenKeys}
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
    return (
      <ul className="list-disc space-y-2 pl-5">
        {value.map((item, idx) => (
          <li key={idx}>
            <JsonRenderer value={item} depth={depth + 1} hiddenKeys={hiddenKeys} />
          </li>
        ))}
      </ul>
    );
  }
  if (isPlainObject(value)) {
    const sanitized = sanitizeObject(value, hiddenKeys);
    const entries = Object.entries(sanitized);
    if (entries.length === 0) {
      return <span className="text-base-content/60">—</span>;
    }
    return (
      <div className="space-y-3">
        {entries.map(([k, v]) => (
          <div key={k} className={depth === 0 ? "rounded-lg border border-base-300 p-3" : ""}>
            <div className="font-semibold">{humanizeKey(k)}</div>
            <div className="mt-2">
              <JsonRenderer value={v} depth={depth + 1} hiddenKeys={hiddenKeys} />
            </div>
          </div>
        ))}
      </div>
    );
  }
  return <div className="break-words">{String(value)}</div>;
}

export default JsonRenderer;
